import React from 'react'
import PropTypes from 'prop-types'

import AutoComplete from 'material-ui/AutoComplete';

import EditItemButtons from '../common/EditItemButtons'
import Checkbox from 'material-ui/Checkbox'

const emptyMaterial = {
  name: '',
  cost: '',
  quantity: '',
  units: '',
  store: '',
  notes: '',
  reimbursed: false,
  billable: false
}

export default class MaterialAddItem extends React.Component {

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    materialsDataSource: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = emptyMaterial
  }

  componentDidMount() {
    if (this.nameInput) {
      this.nameInput.focus()
    }
  }

  resetFields = () => {
    this.setState(emptyMaterial)
  }

  handleInputValueChanged = (event, propertyName) => {
    this.setState({
      [propertyName]: event.target.value
    })
  }

  handleAutocompleteUpdateInput = searchText => {
    this.setState({
      name: searchText
    })
  }

  handleSave = () => {
    const validationResult = this.validateMaterialInput(this.state)
    if (validationResult.success) {
      this.props.onSave(this.state)
      this.resetFields()
    }
    else {
      alert(validationResult.error)
    }
  }

  handleAutocompleteItemSelected = (item, index) => {
    if (index >= 0 && index < Object.keys(this.props.materialsDataSource).length) {
      const key = Object.keys(this.props.materialsDataSource)[index]
      const material = this.props.materialsDataSource[key]
      const materialAutocomplete = {}
      if (material.cost) {
        materialAutocomplete.cost = material.cost.toString()
      }
      if (material.units) {
        materialAutocomplete.units = material.units
      }
      if (material.quantity) {
        materialAutocomplete.quantity = material.quantity.toString()
      }
      if (material.store) {
        materialAutocomplete.store = material.store
      }
      if (material.reimbursed) {
        materialAutocomplete.reimbursed = material.reimbursed
      }
      if (material.billable) {
        materialAutocomplete.billable = material.billable
      }
      if (material.notes) {
        materialAutocomplete.notes = material.notes
      }
      if (Object.keys(materialAutocomplete).length) {
        this.setState(materialAutocomplete)
      }
    }
  }

  validateMaterialInput = newMaterial => {
    if (!newMaterial.name) {
      return { error: 'Name field is required.' }
    }
    return { success: true }
  }

  getAutocompleteDataSource = () => {
    return this.props.materialsDataSource.map(m => m.name)
  }

  render() {
    return (
      <div
        style={styles.container}>
        <div style={styles.inputRow}>
          <div style={styles.inputContainer}>
            <div style={styles.inputLabel}>Item Name:</div>
            <AutoComplete
              style={{ display: 'flex', flex: 1 }}
              textFieldStyle={{ ...styles.input, ...styles.nameInput }}
              dataSource={this.getAutocompleteDataSource()}
              filter={AutoComplete.caseInsensitiveFilter}
              animated={false}
              fullWidth={true}
              ref={input => this.nameInput = input}
              id='name'
              underlineStyle={{ display: 'none' }}
              searchText={this.state.name}
              onUpdateInput={this.handleAutocompleteUpdateInput}
              onNewRequest={this.handleAutocompleteItemSelected} />
          </div>
        </div>
        <div style={styles.inputRow}>
          <div style={styles.inputContainer}>
            <div style={styles.inputLabel}>Cost:</div>
            <input
              style={{ ...styles.input, ...styles.spaceInRow }}
              type='number'
              step='0.01'
              value={this.state.cost}
              onChange={event => this.handleInputValueChanged(event, 'cost')} />
          </div>

          <div style={styles.inputContainer}>
            <div style={styles.inputLabel}>Quantity:</div>
            <input
              style={{ ...styles.input, ...styles.spaceInRow }}
              type='number'
              step='1'
              value={this.state.quantity}
              onChange={event => this.handleInputValueChanged(event, 'quantity')} />
          </div>

          <div style={styles.inputContainer}>
            <div style={styles.inputLabel}> Units: </div>
            <input
              style={styles.input}
              type='text'
              value={this.state.units}
              onChange={event => this.handleInputValueChanged(event, 'units')} />
          </div>
        </div>

        <div style={styles.inputRow}>
          <div style={styles.inputContainer}>
            <div style={styles.inputLabel}> Source: </div>
            <input
              style={styles.input}
              type='text'
              value={this.state.store}
              onChange={event => this.handleInputValueChanged(event, 'store')} />
          </div>
        </div>

        <div style={styles.inputRow}>
          <div style={styles.checkInputContainer}>
            <div style={styles.inputLabel}> Reimbursable: </div>
            <Checkbox
              style={{ width: '24px', padding: 8 }}
              iconStyle={{ fill: '#8c8c8c' }}
              checked={this.state.reimbursed}
              onCheck={(event, reimbursed) => { this.setState({ reimbursed }) }}/>
          </div>

          <div style={styles.checkInputContainer}>
            <div style={styles.inputLabel}> Billable: </div>
            <Checkbox
              style={{ width: '24px', padding: 8 }}
              iconStyle={{ fill: '#8c8c8c' }}
              checked={this.state.billable}
              onCheck={(event, billable) => { this.setState({ billable }) }}/>
          </div>
        </div>

        <div style={styles.inputRow}>
          <div style={styles.multilLineInputContainer}>
            <div style={styles.inputLabel}> Notes: </div>
            <textarea
              style={{ ...styles.input, resize: 'vertical' }}
              cols="40"
              rows="4"
              type='text'
              value={this.state.notes}
              onChange={event => this.handleInputValueChanged(event, 'notes')}>
            </textarea>
          </div>
        </div>

        <EditItemButtons
          primaryButtonText={'Add'}
          onCancel={this.props.onCancel}
          onSave={this.handleSave} />
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    flex: 1,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  },

  nameInput: {
    height: 24
  },

  checkInputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },

  multilLineInputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    flex: 1
  },

  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12
  },

  inputLabel: {
    color: '#757575',
    marginRight: 8,
    fontSize: 14
  },

  spaceInRow: {
    marginRight: 12
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/MaterialAddItem.js